module.exports = __webpack_public_path__ + "static/media/icon_account_black.f8937762.png";